import { PROSPECTS_ACTIONS } from 'constants/Actions/Prospects';

// Estado inicial del reducer
const aInitialState = {
    aProspects: [],
    nTotalPages: 0,

    oProspect: null,

    bIsError: false,
    bIsSuccess: false,
    bImportSuccess: false,

    aStages: [],
    aTraceabilities: [],

    oIndividual: null,

    aVisits: [],
    sFile: null,

    aDataImport: [],
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los individuos del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const ProspectReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case PROSPECTS_ACTIONS.GET:
            return { ...aState, aProspects: oAction.data.data, nTotalPages: oAction.data.pages };
        case PROSPECTS_ACTIONS.FIND:
            return { ...aState, oProspect: oAction.data };
        case PROSPECTS_ACTIONS.GET_STAGES:
            return { ...aState, aStages: oAction.data };
        case PROSPECTS_ACTIONS.GET_INDIVIDUAL:
            return { ...aState, oIndividual: oAction.data };
        case PROSPECTS_ACTIONS.TRACEABILITY:
            return { ...aState, aTraceabilities: oAction.data };
        case PROSPECTS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case PROSPECTS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case PROSPECTS_ACTIONS.GET_VISITS:
            return { ...aState, aVisits: oAction.data };
        case PROSPECTS_ACTIONS.GET_REPORT_VISITS:
            return { ...aState, sFile: oAction.data };
        case PROSPECTS_ACTIONS.SUCCESS_UPLOAD_FILE:
            return { ...aState, bImportSuccess: true, aDataImport: oAction.data };
        case PROSPECTS_ACTIONS.CLEAN:
            return { ...aState, bIsError: false, bIsSuccess: false, oProspect: null, aTraceabilities: [], oIndividual: null, aVisits: [], sFile: null };
        case PROSPECTS_ACTIONS.CLEAN_IMPORTS:
            return { ...aState, bImportSuccess: false, aDataImport: [] };
        default:
            return aState;
    }
}
